/**
 * Rehman Travel — brand tokens
 */

export const BRAND = {
  name: 'Rehman Travel',
  shortName: 'Rehman',
  tagline: 'Travel, simply planned',
  legalName: 'Rehman Travel',
};

export default BRAND;
